import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../components/layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa6';
import { deleteSubscriber, getSubscriberList, updateSubscriberStatus } from '../../axioscalls/useaxios';
import styled from '../../assets/css/user.module.css';

const SubscriberList = () => {


    const navigate = useNavigate();


    const [userList, setUserList] = useState([]);
    const [userListBackUp,setUserListBackup] = useState([]);
    const [searchText, setSearchText] = useState("");
    

    const getSubscribersList = async () => {
		var subscriberData = await getSubscriberList({searchText});
        console.log("🚀 ~ getSubscribersList ~ subscriberData:", subscriberData)
        
		if (subscriberData.userValue.data) {
			
			setUserList(subscriberData.userValue.data);
            setUserListBackup(subscriberData.userValue.data);
		}	
	}

	const add = async () => {
      
        let data = userList.some((val)=>val.maySent)
        if(data){
            navigate("/subscriberadd");
        }else{
            toast.error('Please select At least one Mail',1000);
        }
	}

	const handleChangemaysent = async (event) => {
		let {id , checked} = event.target;
		
		let handlemaychange = await updateSubscriberStatus({email : id , maySentChecked : checked});
		if (handlemaychange) {
			
			// toast.success('Success...',1000);
            getSubscribersList();
		}
		// setTimeout(()=>{
		// 	window.location.reload();
		// },2000)
	}

	useEffect(() => {
		getSubscribersList();
	}, [searchText]);

    const removeSubscriber = async (subscriberId) => {
        let sendData = {
            subscriberId:  subscriberId
        };
        let resp = await deleteSubscriber(sendData);
        if(resp?.userValue?.sucess){
            toast.success('Subscriber deleted succesfully',1000);
            getSubscribersList();
        }
        
    }

        const columns = [
            {
    
                key: "S.No",
                name: "S.No",
                className: "px-2",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) =>
                    <p className='ps-2'>{index +1}</p>
            },
           
            {
    
                key: "EmailId",
                name: "Email",
                // // className: "tokenId",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) =>
                    <p>{row.EmailId}</p>
            },
            {
    
                key: "Action",
                name: "Action",
                // className: "tokenBid",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => {
                    return (
                        <Fragment>
                            {row && 
                            <>
                            <Form.Check type="checkbox" name={row._id} id={row.EmailId} checked={row.maySent} onChange={(event) =>{ handleChangemaysent(event)}}/>
                            <button className='btn btn-danger btn-sm ms-2' onClick={() => { removeSubscriber(row?._id) }} type='button'><FaTrash /></button> 
                            </>
                            }
                        </Fragment>
                    );
                }
    
            },
        ];

        // useEffect(()=>{
        //     let instUserList = userListBackUp;
        //     if(searchText){
        //         instUserList = userListBackUp.filter((check)=>check?.email?.includes(searchText));
        //     }
        //     setUserList([...instUserList]);
        // },[searchText,userListBackUp]);

    return (
        <>
        <div>
              <Layout>
                <div className={`${styled.innercontents}`}>
                  <div className={`row mx-0`}>
                    <div className={`col-12`}>
        
                      <div className={`${styled.tablesec}`}>
                        <h5 className={`${styled.cardtitle}`}>Subscriber List</h5>
                    <Link to="/subscriberadd" className=" allbtn text-decoration-none" onClick={add}>Send News Letter</Link>
        
                        <DataTable
                          className='react-datatables'
                          columns={columns}
                          data={userList}
                          pagination // Enable pagination
                          // paginationPerPage={2} // Rows per page
                          paginationRowsPerPageOptions={[5, 10, 15, 20]} // Page options
                        />
                      </div>
                    </div>
        
        
                  </div>
                </div>
        
              </Layout>
        
            </div>
        </>
       
    )
}

export default SubscriberList;